// let baseParam = {appkey: "web-nwxHX2RAUMChnrah", "grant_type": "password", scope: "server"};
// let baseParam = {appkey: "web-BFmMDqYPihOYuXCL", "grant_type": "password", scope: "server"};
let baseParam = {appkey: "A09D1509B5C64FBE9ABBA746258852EF", "grant_type": "password", scope: "server"};


function setupLanguage() {
    let globalData = globalDataInit();
    let language = location.pathname.split("/")[1];
    if (language.toUpperCase() === "EN") {
        globalData.set("languageType", 0);
    } else if (language.toUpperCase() === "ES") {
        globalData.set("languageType", 1);
    } else {
        globalData.set("languageType", 0);
    }
    return globalData;
}

// 变量函数
function globalDataInit() {
    let fn = {}
    let obj = {
        languageList: [{name: 'English', lan: 'EN', dir: "", value: "7"}, {
            name: 'Español',
            lan: 'ES',
            dir: "es",
            value: "10"
        }],
        languageType: 0,
        langData: {
            'EN': {
                login: "Login",
                signin: "Sign in",
                already_have_account: "Already have an account?",
                login_here: "Log in here",
                new_customer: "New customer?",
                create_an_account: "Create an account",
                email_address: "Email address",
                your_email_address: 'Your Email address',
                password: "Password",
                forget_password: 'Forgot your password?',
                agree_tips: 'By continuing, you hereby agree to the PRIVACY POLICY and TERMS OF USE. Topdon will use the information provided by the third party you selected to register or log in.',
                agree_tips2: "Get announcements, recommendations and updates about TOPDON products, services, software updates and more.",
                privacy_policy: "TOPDON PRIVACY POLICY",
                and: "and",
                term_of_use: "TERMS OF USE.",
                agree_tips3: "I agree to comply with the ",
                create_account: "Create account",
                verification_code: "Verification code",
                send: 'Send',
                create: "Create",
                reset_password: "Reset your password",
                send_tips: "We will send you an email to reset your password.",
                send_tips2: 'Verification code has been sent to your email!',
                new_password_again: "Enter new password again",
                submit: 'Submit',
                cancel: "Cancel",
                invalid_email: "Invalid email.",
                password_tips: 'The password must be at least 8 characters and at least two combinations of uppercase letters, lowercase letters, numbers and symbols (only: @$!%*#_~?&.-).',
                password_tips2: "Two password are different.",
                valid_code_require: "Valid code is required.",
                valid_code_error: "Verification Code Error!",
                reset_successful: "Password reset successfully, please sign in again.",
                email_password_error: "Incorrect email or password.",
                email_already_exist: "The email address has already been registered!",
                should_agree_tips: "Please agree PRIVACY POLICY and TERMS OF USE.",
                signup_successful: "Registration successful!",
                unkonwn_exception: "Problem encountered, please try again later.",
              subscribe_success:"Thank you for subscribing.",
              already_subscribe:"You have already subscribed to our newsletter.",
              register_success:"Registration successful! Please login.",
              user_not_exist:"User does not exist!"
            }, 'ES': {
                login: "Iniciar sesión",
                signin: "Iniciar sesión",
                already_have_account: "¿Ya tiene una cuenta?",
                login_here: "Inicie sesión aquí",
                new_customer: "¿Nuevo cliente?",
                create_an_account: "Crear una cuenta",
                email_address: "Dirección email",
                your_email_address: 'Tu dirección email',
                password: "Contraseña",
                forget_password: '¿Olvidó su contraseña?',
                agree_tips: 'Al continuar, usted acepta la POLÍTICA DE PRIVACIDAD y los TÉRMINOS DE USO. Topdon utilizará la información proporcionada por el tercero que usted seleccionó para registrarse o iniciar sesión.',
                agree_tips2: "Obtenga anuncios, recomendaciones y actualizaciones sobre productos, servicios, actualizaciones de software y más de TOPDON.",
                privacy_policy: "POLÍTICA DE PRIVACIDAD",
                and: "y",
                term_of_use: "los TÉRMINOS DE USO de TOPDON.",
                agree_tips3: "Acepto cumplir con la ",
                create_account: "Crear cuenta",
                verification_code: "Código de verificación",
                send: 'Enviar',
                create: "Crear",
                reset_password: "Restablecer su contraseña",
                send_tips: "Le enviaremos un email para restablecer su contraseña",
                send_tips2: '¡El codigo de verificación ha sido enviado a tu email!',
                new_password_again: "Ingrese su contraseña nuevamente",
                submit: 'Enviar',
                cancel: "Cancelar",
                invalid_email: "Email incorrecto",
                password_tips: 'La contraseña debe tener al menos 8 caracteres y al menos dos combinaciones de letras mayúsculas, minúsculas, números y símbolos (solo: @$!%*#_~?&.-).',
                password_tips2: "Las dos contraseñas son diferentes",
                valid_code_require: "Se requiere un código válido",
                valid_code_error: "Error en el código de verificación",
                reset_successful: "Restablecimiento de contraseña exitoso, inicie sesión nuevamente.",
                email_password_error: "Email o contraseñas incorrectos",
                email_already_exist: "¡La dirección de correo electrónico ya ha sido registrada!",
                should_agree_tips: "Por favor acepte LA POLÍTICA DE PRIVACIDAD y los TÉRMINOS DE USO",
                signup_successful: "¡Registro exitoso!",
                unkonwn_exception: "¡Anomalía desconocida!",
              subscribe_success:"Gracias por suscribirte",
              already_subscribe:"Ya estás suscrito a nuestra newsletter.",
              register_success:"¡Registro exitoso!",
              user_not_exist:"Esta dirección de email no está registrada."
            }
        },
    }
    fn.set = function (key, value) {
        obj[key] = value
    }
    fn.get = function (key) {
        return obj[key]
    }
    return fn

}

function setCookie(name, value) {

    //设置名称为name,值为value的Cookie
    var expdate = new Date();   //初始化时间
    expdate.setTime(expdate.getTime() + 24 * 3600000);   //时间
    document.cookie = name + "=" + value + ";expires=" + expdate.toGMTString() + ";path=/";

    //即document.cookie= name+"="+value+";path=/";   时间可以不要，但路径(path)必须要填写，因为JS的默认路径是当前页，如果不填，此cookie只在当前页面生效！~
}

/**按ascii码从小到大排序
 *
 * @param obj
 * @returns {string}
 */
function sort_ascii(obj) {
    let arr = new Array();
    let num = 0;
    for (let i in obj) {
        arr[num] = i;
        num++;
    }
    let sortArr = arr.sort();
    //let sortObj = {};    //完成排序值
    let str = '';             //自定义排序字符串
    for (let i in sortArr) {
        str += sortArr[i] + '=' + obj[sortArr[i]] + '&';
        //sortObj[sortArr[i]] = obj[sortArr[i]];
    }
    //去除两侧字符串
    let char = '&'
    str = str.replace(new RegExp('^\\' + char + '+|\\' + char + '+$', 'g'), '');

    return str;
}


function getCookie(name) {
    let arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
        return unescape(arr[2]);
    } else {
        return null;
    }
}

function delCookie(name) {
    let exp = new Date();
    exp.setTime(exp.getTime() - 1);
    let cval = getCookie(name);
    if (cval != null) {
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString() + ";domain=localhost;path=/";
    }
}

function showTip(msg, duration, type, callback) {
    duration = isNaN(duration) ? 3000 : duration;
    let box = document.createElement('div');
    let container = document.createElement('div');
    let img = document.createElement("img");
    let text = document.createElement('div');
    box.className = "toast";
    container.className = "container-box"
    text.className = "text";
    text.innerHTML = msg;
    if (type === "error") {
        if (msg.length > 76) {
            img.src = "https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/icon-error_2x_d5fd19bd-a8ca-450e-9115-d4aa5bf0e515.png?v=1648656070";
            text.style.cssText = "line-height:20px";
        } else {
            box.style.cssText = "width:40%";
            img.src = "https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/icon-error.png?v=1648656070";
        }
    } else {
        img.src = "https://cdn.shopify.com/s/files/1/0590/5789/7634/files/icon-success.png?v=1740561972";
    }
    box.appendChild(container);
    container.appendChild(img);
    container.appendChild(text);
    document.body.appendChild(box);
    setTimeout(function () {
        let d = 0.5;
        box.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        box.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(box)
            if (callback) {
                callback();
            }
        }, d * 1000);
    }, duration);
}

function showToast(msg, duration, callback) {
    duration = isNaN(duration) ? 3000 : duration;
    let m = document.createElement('div');
    m.innerHTML = msg;
    m.style.cssText = "width:40%; min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:40%; left:40%; z-index:999999;";
    document.body.appendChild(m);
    setTimeout(function () {
        let d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m)
            if (callback) {
                callback();
            }
        }, d * 1000);
    }, duration);
}

function showToastCenter(msg, duration, callback) {
    duration = isNaN(duration) ? 3000 : duration;
    let m = document.createElement('div');
    m.innerHTML = msg;
    m.style.cssText = "width:40%; min-width:180px; background:#000; opacity:0.6; height:auto;min-height: 30px; color:#fff; line-height:30px; text-align:center; border-radius:4px; position:fixed; top:40%; left:30%; z-index:999999;";
    document.body.appendChild(m);
    setTimeout(function () {
        var d = 0.5;
        m.style.webkitTransition = '-webkit-transform ' + d + 's ease-in, opacity ' + d + 's ease-in';
        m.style.opacity = '0';
        setTimeout(function () {
            document.body.removeChild(m)
            if (callback) {
                callback();
            }
        }, d * 1000);
    }, duration);
}

function encrypt(str) {
    let key = CryptoJS.enc.Utf8.parse("thanks,lenkor123");
    let iv = CryptoJS.enc.Utf8.parse("thanks,lenkor123");
    let srcs = CryptoJS.enc.Utf8.parse(str);
    let encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding
    });
    return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}


function sendRequest(uri, method, headers, param, successCallback, errorCallback) {
    headers["clientType"] = 3;
  let globalData = setupLanguage();
    let language = globalData.get('languageList')[globalData.get('languageType')];
    headers["Languageid"] = language.value;
    $.ajax({
        url: "https://official-web-api.topdon.com" + uri,
        type: method,
        contentType: "application/json;charset=utf-8",
        data: JSON.stringify(param),
        headers: headers,
        dataType: "json",
        success: function (data) {
            if (data.code === 2000) {
                successCallback(data.data||data);
            } else {
                if (errorCallback) {
                    errorCallback(data);
                }
            }
        },
        error: function (data) {
            if (data.status === 401) {
                delCookie("access_token");
                showToastCenter("Unknow Exception!");
            } else {
                let json = data.responseJSON;
                errorCallback(json);
            }
        }
    });
}

function sendRequestWithQs(uri, method, headers, param, successCallback, errorCallback) {
    headers["clientType"] = 3;
  let globalData = setupLanguage();
    let language = globalData.get('languageList')[globalData.get('languageType')];
    headers["Languageid"] = language.value;
    $.ajax({
        url: uri, type: method, data: param, headers: headers, dataType: "json", success: function (data) {
            if (data.code === 2000) {
                successCallback(data);
            } else {
                showToast(data.msg, 3000);
                if (errorCallback) {
                    errorCallback(data);
                }
            }
        }, error: function (data) {
            if (data.status === 401) {
                delCookie("access_token");
                showToastCenter("Unknow Exception!");
            } else {
                let json = data.responseJSON;
                showToast(json.msg, 3000);
                errorCallback(json);
            }
        }
    });
}

function randomString(len) {
    len = len || 32;
    let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
    let maxPos = $chars.length;
    let pwd = '';
    for (let i = 0; i < len; i++) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd;
}

function signin(param, successCallback, errorCallback) {
    postOwner("/topdon_user/signin", param, function (data) {
        setCookie("access_token", data.tokenType + " " + data.accessToken);
        successCallback(data);
    }, errorCallback);
}

function getSign(uri, param) {
    let timestamp = new Date().getTime();
    let nonceStr = randomString(10);
    let paramData = $.extend({}, baseParam, {nonceStr: nonceStr, timestamp: timestamp})
    let signTemp = sort_ascii($.extend({}, param, paramData));
    let hash = CryptoJS.MD5(signTemp + "&appSecret=63E4D415350D4F81B6EA512564810F5B").toString().toUpperCase();
    return uri + "?" + signTemp + "&sign=" + hash
}

function getWithSign(uri, headers, param, successCallback, errorCallback) {
    let accessToken = getCookie("access_token");
    let token = {"Authorization": "Basic bGVua29yOmxlbmtvcg=="}
    let url = getSign(uri, {});
    sendRequestWithQs(url, "GET", $.extend({}, headers, token), param, function (data) {
        successCallback(data.data);
    }, errorCallback)
}

function postWithSign(uri, headers, param, successCallback, errorCallback) {
    let accessToken = getCookie("access_token");
    let token = {"Authorization": "Basic bGVua29yOmxlbmtvcg=="}
    let url = getSign(uri, {});
    sendRequest(url, "POST", $.extend({}, headers, token), param, successCallback, errorCallback)
}

function postWithSignQs(uri, headers, param, successCallback, errorCallback) {
    let accessToken = getCookie("access_token");
    let token = {"Authorization":  "Basic bGVua29yOmxlbmtvcg=="}
    let url = getSign(uri, param);
    sendRequestWithQs(url, "POST", $.extend({}, headers, token), param, successCallback, errorCallback)
}

function get(uri, headers, param, successCallback, errorCallback) {
    sendRequest(uri, "GET", headers, param, successCallback, errorCallback)
}

function post(uri, headers, param, successCallback, errorCallback) {
    sendRequest(uri, "POST", headers, param, successCallback, errorCallback)
}

function getOwner(uri, param, successCallback, errorCallback) {
    sendRequestOwner(uri, "GET", {}, param, successCallback, errorCallback)
}

function postOwner(uri, param, successCallback, errorCallback) {
    sendRequestOwner(uri, "POST", {}, param, successCallback, errorCallback)
}

function sendRequestOwner(uri, method, headers, param, successCallback, errorCallback) {
    headers["X-Requested-With"] = "Hiwie-Fetch";
    if (typeof param === "string") {
        headers["Content-Type"] = "application/json";
    }
    $.ajax({
        url: "https://official-web-api.topdon.com/api" + uri, type: method, data: param, headers: headers, dataType: "json", success: function (data) {
            if (data.success) {
                successCallback(data.success);
            } else {
                //showToast(data.error.message);
                if (errorCallback) {
                    errorCallback(data);
                }
            }
        }, error: function (data) {
            if (data.status === 401) {
                let url = window.location.href;
                delCookie("access_token");
                location.href = "/account/login?returnTo=" + url;
            } else {
                let json = data.responseJSON;
                errorCallback(json);
            }
        }
    });
}


//以成员函数形式设置插件
(function ($) {
    $.fn.extend({
        showLoading: function () {

            let html = "<div class='topdon-loading'><div class='loading-bg'><img src='https://cdn.shopifycdn.net/s/files/1/0590/5789/7634/files/loading.gif?v=1676657553'><span>Loading...</span></div></div>"
            if ($(".topdon-loading").length <= 0) {
                this.append(html);
            }

            return this;    //为了支持链式操作 要返回当前对象
        }, hideLoading: function () {
            $(".topdon-loading").remove();
            return this;
        }
    })
})(jQuery);
